import styled from 'styled-components';

export const DefaultHeading = styled.h2`
  font-family: ${props => props.theme.fonts.caroline}, Arial, sans-serif;
  font-size: ${props => props.theme.fontSizes.xxl};
  color: black;
  font-weight: normal;
  margin: 0;
`